import { useForm } from "react-hook-form";
import { VisitaInfo } from "../../../../types/visitas";
import { useGetVisitaByIdQuery, useUpdateVisitInformationMutation } from "../../../../api/visitasApi";
import { useGetFrecuenciaFilterDataQuery } from "../../../../api/filter/dataFilterApi";
import { AvailableEmpresaFilters } from "../../../../utils/enums";
import { CancelButton } from "../../../UtilitiesComponents/CancelButton";
import { SaveButton } from "../../../UtilitiesComponents/SaveButton";
import { useState } from "react";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../../../UtilitiesComponents/ErrorMessage";

export type VisitInformation = {
    fecha: string;
    horaInicio: string;
    horaFin: string;
    turnoId: string;
}

interface Props {
    visit: VisitaInfo;
    onCancel?: () => void;
}

export function parseValidTimeSpanFormat(time: string): string {
    const parts = time.split(":");

    if(parts.length === 2)
        return time + ":00";

    return time;
}

export function EditVisitInfoForm({ visit, onCancel }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { data: visita, isFetching: visitaIsFetching, isSuccess, isError } = useGetVisitaByIdQuery({ visitaId: visit.id, rawFormat: true });
    const { data: inputValues, isFetching: inputValuesIsFetching } = useGetFrecuenciaFilterDataQuery([AvailableEmpresaFilters.Turnos]);

    const [updateVisit, { isLoading }] = useUpdateVisitInformationMutation();

    const {
        register,
        handleSubmit,
        formState: { isDirty }
    } = useForm<VisitaInfo>({
        values: visita
    });

    const handleOnSubmit = handleSubmit(async (data) => {
        try {
            setErrorMessage(null);

            const request: VisitInformation = {
                fecha: data.fecha,
                horaInicio: parseValidTimeSpanFormat(data.horaInicio),
                horaFin: parseValidTimeSpanFormat(data.horaFin),
                turnoId: data.turno,
            }

            console.log(request);

            await updateVisit({ visitaId: visit.id, data: request }).unwrap();
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    });

    if(visitaIsFetching || inputValuesIsFetching)
        return (
            <div className="flex flex-col justify-center items-center overflow-hidden bg-gray-100 rounded-md p-2 border border-gray-600 h-[210px]">
                <CircularProgress />
            </div>
        );

    return (
        <div className="flex flex-col overflow-hidden bg-gray-100 rounded-md p-2 border border-gray-600">
            <p className="font-semibold text-lg pb-2">Editar información</p>

            <form onSubmit={handleOnSubmit}>
                <div className="flex gap-x-3 justify-between">
                    <div>
                        <label className="text-sm font-semibold">Fecha</label>
                        <input 
                            {...register("fecha")}
                            type="date"
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm bg-white" />
                    </div>

                    <div>
                        <label className="text-sm font-semibold">Hora de inicio</label>
                        <input
                            {...register("horaInicio")}
                            type="time"
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm bg-white"/>
                    </div>

                    <div>
                        <label className="text-sm font-semibold">Hora de fin</label>
                        <input
                            {...register("horaFin")}
                            type="time"
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm bg-white"/>

                    </div>
                </div>

                <div className="grid grid-cols-1 gap-x-2">
                    <div>
                        <label className="text-sm font-semibold">Turno</label>
                        <select
                            {...register("turno")}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm">
                            <option value={0} hidden>Seleccionar vendedor</option>
                            {inputValues?.turnos?.map((turno, index) => (
                            <option value={turno.id} key={index}>{turno.nombre}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {errorMessage && (
                    <div className="pt-3">
                        <ErrorMessage>
                            {errorMessage}
                        </ErrorMessage>
                    </div>
                )}

                <div className="flex gap-x-2 justify-center pt-3 h-[40px]">
                    {isLoading
                    ?
                    <CircularProgress sx={{
                        "--CircularProgress-progressThickness": "4px",
                        "--CircularProgress-trackThickness": "4px",
                        "--CircularProgress-size": "24px"
                    }}/>
                    :
                    <>
                    <SaveButton
                        disabled={!isDirty}
                        text="Actualizar"
                        type="submit"/>

                    <CancelButton
                        text="Cancelar"
                        onClick={onCancel}/>
                    </>
                    }
                </div>
            </form>
        </div>
    );
}